import { compose, withStateHandlers } from 'recompose';

const withCollapsible = () => compose(
  withStateHandlers(
    (ownProps: OwnProps) => ({
      isOpen: ownProps.defaultOpen || false,
    }),
    {
      onToggle: ({ isOpen }) => () => ({
        isOpen: !isOpen,
      }),
      onOpen: () => () => ({
        isOpen: true,
      }),
      onClose: () => () => ({
        isOpen: false,
      }),
    },
  ),
);

interface OwnProps {
  defaultOpen?: boolean;
}

export interface withCollapsibleDefs {
  isOpen: boolean;
  onToggle();
  onOpen();
  onClose();
}

export default withCollapsible;
